(ns ncr.widgets.fragment
  (:require
   [goog.events :as gevents]
   [goog.events.EventType :as EventType]
   [uix.core.alpha :as uix]
   [ncr.etc.pf :as pf]
   [ncr.widgets.core :as w]))

(defn c-promote [disabled? on-promote-click on-quick-promote-click]
  (let
    [dd-node-ref (uix/ref nil)
     open? (uix/state false)]

    (uix/with-effect [@open?]
      (when @open?
        (let
          [listener-id
           (gevents/listen js/document.body EventType/CLICK
             (fn [e]
               (when-some [dd-node @dd-node-ref]
                 (when (and @open? (not (.contains dd-node (.-target e))))
                   (reset! open? false)))))]
          #(gevents/unlistenByKey listener-id))))

    (let [params {:is-open @open?
                  :on-select #(reset! open? false)
                  :dropdown-items [[pf/c-dropdown-item {:on-click on-promote-click} "Move to Accepted…"]]

                  :toggle
                  [pf/c-dropdown-toggle
                   {:is-disabled disabled?
                    :split-button-variant :action

                    :on-toggle
                    (fn [_ e]
                      (reset! dd-node-ref (-> e .-currentTarget (.closest ".pf-c-dropdown")))
                      (swap! open? not))

                    :split-button-items
                    [(uix/as-element
                       (pf/c-dropdown-toggle-action
                         {:key :quick
                          :on-click
                          (fn [_]
                            (reset! open? false)
                            (on-quick-promote-click))}
                         [w/c-toolbar-icon
                          {:icon :rocket-launch-outline}]))]}]}]
      (if disabled?
        [pf/c-dropdown params]
        [pf/c-tooltip {:content "Move to Accepted"}
         [pf/c-dropdown params]]))))
